import { Button, Typography, notification, Col, Form, Row } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import React, { useState } from "react";
import { useForm } from "antd/es/form/Form";
import TextArea from "antd/es/input/TextArea";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { postAddSaison } from "../../api/Post";

const { Title, Text } = Typography;

const Context = React.createContext({ name: "Default" });

const AddSaison = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { serie } = state;

  const [form] = useForm();

  const [errorMsg, setErrorMsg] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [api, contextHolder] = notification.useNotification();

  const openNotification = (saison) => {
    console.log(saison);
    api.success({
      message: `Saison ${saison.number} enregistré`,
      description: "",
      placement: "topLeft",
    });
  };

  const onFinish = async (values) => {
    setIsLoading(true);

    if (values.sumup.length > 500) return setErrorMsg("Max 500 car.");

    const res = await postAddSaison(values.sumup, serie.id);

    console.log(res);

    if (res.error) setErrorMsg(res.error);
    else openNotification(res.season);

    setIsLoading(false);
  };

  return (
    <>
      <Context.Provider value={{ name: "AddSaison" }}>
        {contextHolder}
        <Row style={{ marginBottom: 50 }} align="middle">
          <Col span={1}>
            <Button
              shape="circle"
              icon={<ArrowLeftOutlined />}
              onClick={() => {
                navigate(-1);
              }}
            />
          </Col>
          <Col span={20}>
            <Title style={{ margin: 0, marginLeft: 10 }} level={3}>
              Ajouter une saison
            </Title>
          </Col>
        </Row>
        <Form form={form} layout="vertical" onFinish={onFinish}>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label="Résumé"
                name="sumup"
                rules={[
                  {
                    required: true,
                    message: "Résumé de 500 caractères maximum",
                  },
                ]}
              >
                <TextArea
                  placeholder="Il était une fois Lulu à Brest qui allait à la plage faire du surf..."
                  autoSize={{ minRows: 3, maxRows: 5 }}
                />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item wrapperCol={{ span: 16 }}>
            <Button loading={isLoading} type="primary" htmlType="submit">
              Ajouter
            </Button>
          </Form.Item>
          <Text type="danger">{errorMsg}</Text>
        </Form>
      </Context.Provider>
    </>
  );
};

export { AddSaison };
